module.exports = __webpack_public_path__ + "img/pass_green.7c5a4c0c.svg";